import React,{useState,useRef,useEffect} from 'react'
import Steps from '../../../components/Steps/'
import VerifyReference from './VerifyReference'
import VerifySecurityQuestion from './VerifiedSecurityQuestion'
import UpdatePassword from './UpdatePassword'
import { useDispatch, useSelector} from 'react-redux'

import { Toast } from 'primereact/toast'

const PasswordReset = () => {

  const interactiveItems = [
    { label: 'Reset Password' },
    { label: 'Reset Password' }
  ];


  const toast = useRef(null)
  const [activeIndex,setActiveIndex] = useState(0)
  const [defaultLoginURL] = useState('/accountmanagement/auth/my-profile')


  
  return <div className="activate-account-card">
    <Toast ref={toast}/>
    <div className="steps-title">{activeIndex !== null && activeIndex !== 2 ? `${interactiveItems[activeIndex].label}` : null}</div>
    <div className="steps-container-margin">
      <Steps items={interactiveItems} currentIndex={activeIndex} />
    </div>
    <div className="center">

      <hr/>
      {activeIndex === 0 ? <VerifyReference toast={toast} setActiveIndex={setActiveIndex} defaultLoginURL={defaultLoginURL}/> : null }
      {activeIndex === 1 ? <VerifySecurityQuestion toast={toast} setActiveIndex={setActiveIndex} defaultLoginURL={defaultLoginURL}/> : null }
      {/* {activeIndex === 2 ? <UpdatePassword  toast={toast} setActiveIndex={setActiveIndex} defaultLoginURL={defaultLoginURL}/> : null } */}
    </div>
</div>

}

export default PasswordReset